import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class Ecommerce extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> E-commerce </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      <b>X-tended Reality (XR): The next-gen technology for ecommerce</b>
                      <br></br>
                      Retail industry is concentrating all the effort in delivering compelling 
                      and more inspiring customer experiences. In this endeavour, retailers are 
                      focusing on a new concept of Extended Reality (XR), which is an amalgamation 
                      of physical and virtual worlds that has the power to fundamentally change 
                      the way we shop online.
                      <br></br>
                      XR is a continued version of Virtual Reality, Augmented Reality and other 
                      disruptive technologies that help in engaging customers at deeper levels. 
                      Ecommerce companies are pioneering to build new applications using XR.
                      <br></br>
                      This technology has introduced a sensory mix through haptic technology. 
                      To give an example of kind of experience delivered by XR, imagine a customer 
                      shopping for a wrist watch and being able to feel and touch the product 
                      while trying it on virtually.
                      <br></br>
                      XR is quickly becoming a viable option to redefine the customer experience through 
                      XR-commerce. It has provided better purchase opportunities by connecting immersive 
                      experiences with direct product interactions.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Redefining The Consumer Shopping Experience</b>
                      <br></br>
                      One front -- where the e-commerce industry has fallen short of 
                      traditional brick and mortar retail outlets -- is in the actual 
                      shopping experience. Nothing beats walking into a retail store and 
                      interacting with the product or service -- at least until now. 
                      The advent of virtual and augmented reality technologies has provisioned 
                      e-commerce vendors with an avenue to display their wares in immersive detail, 
                      comparable to the real-life experience. 2016 saw Shopify and eBay (in partnership with Myer) 
                      debut virtual reality (VR) options. The former released its personalized virtual 
                      reality app and the latter created a full-featured VR store. Beyond marketing, 
                      the integration of VR and augmented reality (AR) can allow users to visualize 
                      themselves using products immediately and provides a unique way to engage the customer.                   
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>AR commerce: AR-based apps helps in boosting ecommerce Sales</b>
                      <br></br>
                      In the light of Augmented Reality, the dynamic ecommerce market seems to be growing 
                      aggressively.  This technology is adding a new feel to the customer experience by 
                      transforming monotonous browsing to an engaging and immersive shopping experience.
                      <br></br>
                      This is the rise of omnichannel shopping in true sense. Online shopping goes beyond 
                      to browsing through images and videos of models walking the ramp by bringing product 
                      to life in a 3D immersive environment. Such experiences have changed buyer’s perception 
                      by transforming the way purchase decisions are made.
                      <br></br>
                      Ecommerce brands that have implemented AR feature in their app or website have noticed 
                      a significant decrease in number of return requests. When there is no guesswork, 
                      customers are quite sure about their purchase. This leaves little to no scope of 
                      returning the purchased items.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Integrating AR in ecommerce websites made simpler</b>
                      <br></br>
                      Forecasting the rising need of AR-based mobile apps in the near future, 
                      technology giants Apple and Google have developed their own Augmented 
                      Reality platforms. These platforms make it simple for developers to build 
                      ecommerce apps possessing AR features.
                      <br></br>
                      a. ARKit (Augmented Reality for iOS): iOS developers can breathe a sigh of 
                      relief with the availability of ARKit – a platform to build Augmented Reality 
                      iOS apps. This kit reduces effort and time of developers in building apps that 
                      seamlessly blend digital objects and information with the real-world environment.
                      <br></br>
                      b. ARCore (Augmented Reality for Android): ARCore is a software development kit 
                      for Android developers to build innovative apps with Augmented Reality capabilities. 
                      This kit contains all the tools that developers need to make bigger and better 
                      bets with AR that perfectly blend the virtual and real world.
                   </h6>
                    <h6 className = "mt-4 line-height-h">
                      Check out our ever expanding E-commerce templates:
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                <Row className = "mt-5">
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                      <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                      </Col>
                      <Col className ="text-right" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3" > Template 1 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3"> Template 2 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Ecommerce;



// WEBPACK FOOTER //
// ./src/views/Pages/Ecommerce/Ecommerce.js